<template>
    <div class="device-type-manange relative">
        <div class="buttons">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button :id="'roleAdd'" @click="addDeviceType">新增</el-button>
        </div>
        <!-- 表单开始 -->

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">搜索：</span>
                <el-input v-model="name" placeholder=""/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <el-table :data="tableData" border style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="name" label="角色名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="created_date" label="添加时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="updated_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'roleEdit'" @click="goEdit(scope.row)" type="warning" size="small"
                           v-if="scope.row.is_admin!=1">
                    编辑
                </el-button>
                <el-button :id="'roleDel'" @click="del_user(scope.row)" type="danger" v-if="scope.row.is_admin!=1 && scope.row.id!=2 && scope.row.id!=3"
                           size="small">删除
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                name: '',
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                is_submit: false,
            };
        },
        mounted() {
            // 获取角色列表
            this.getList();
            localStorage.setItem('prev_page', 'role_list')
        },
        methods: {
            // 获取所有设备类型
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'roleListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        name: this.name
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },
            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 跳转编辑页
            goEdit(data) {
                this.$router.push({
                    name: "roleEdit",
                    params: {
                        id: data.id,
                        action_list: data.action_list,
                        name:data.name
                    }
                });
            },
            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.name = "";
                this.getList();
            },
            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 跳转添加页
            addDeviceType() {
                this.$router.push({name: "roleAdd", params: {}});
            },

            // 删除设备类型
            del_user(val) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定该删除该角色吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'deleteRole',
                        params: {
                            id: val.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
